/**
 * Created by Jerker Nord on 2019-12-20.
 */
import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {Timeline} from "gsap";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {BonusBunniesBetlineEvent} from "../../betline/BonusBunniesBetlineEvent";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";

export class BonusBunniesIndividualWPController extends BetLineWinIndividualWPController {

    constructor(config:IIndividualWinPresentationConfig, name:string = "BetWayIndividualWin", tweakEnabled?:boolean) {
        super(config, name, tweakEnabled);
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData:IBetLineWinData, timeline:Timeline, startTime:number, symbol:StateReelSymbol, reelId:number, symbolId:number):void {
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            if (BonusBunniesGameConfig.instance.WIN_BELOW_STAKE == false) {
                EventHandler.dispatchEvent(new GameEvent(BonusBunniesBetlineEvent.SHOW_WIN_BET_LINE_WINS, betLineWinData.betLineIndex + 1));
            }
        });
        if (BonusBunniesGameConfig.instance.WIN_BELOW_STAKE == false) {
            timeline.add(BonusBunniesGameModuleConfig.bonusBunniesInitialWPView.getSymbolIndividualWinTL(symbol, reelId, symbolId), startTime);
        }
    }

    public stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);
        BonusBunniesGameModuleConfig.bonusBunniesInitialWPView.cleanupSpineWinSymbols();
    }

    protected playAllNoWinSymbols():void {
        BonusBunniesGameModuleConfig.bonusBunniesInitialWPController.enableAllWinSymbols();
        BonusBunniesGameModuleConfig.bonusBunniesInitialWPController.disableAllNoWinSymbols();
    }
}